// @ts-strict

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IChosenSortValue } from '@app/core/models/core-models';
import { StatisticsSummaryService } from '@services/statistics/statistics-summary.service';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { ColumnManagementOptionsType } from '../../shared-statistics-functions/shared-statistics-functions.component';
import { AvailableStatisticsTableColumns, TableService } from '../table.service';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss']
})
export class TableHeaderComponent implements OnInit, OnDestroy {
  @Input() title?: string;
  @Input() campaignsListLength?: number;
  @Input() isExpandable?: boolean;
  @Input() columnManagementOptions?: ColumnManagementOptionsType;
  @Input() sortDropdownValues?: IChosenSortValue[];
  @Input() filteredDataLength?: number;
  @Input() appliedFiltersBar?: any;
  @Input() choosenSortMethod?: IChosenSortValue;
  @Input() defaultVisibleColumns?: AvailableStatisticsTableColumns[];
  @Input() widgetMode = false;

  public choosenSortValue?: IChosenSortValue;
  public detailsLayout = false;
  public Object = Object;

  public activeColumnsByDefault = ['leads', 'earnings', 'uniqueVisits', 'conversion', 'acceptance', 'epc'];

  private destroy$ = new Subject<void>();

  constructor(private statistics: StatisticsSummaryService, private readonly statisticsTableService: TableService) {}

  ngOnInit(): void {
    this.statisticsTableService
      .getSortMethod()
      .pipe(
        tap(sortMethod => (this.choosenSortValue = sortMethod)),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.statistics.isDetailsLayoutHandler(false);

    this.columnManagementOptions?.map(ele =>
      ele.results.map(el => {
        el.checked = this.activeColumnsByDefault.includes(el.column);
        this.statistics.setColumnsVisibility(el);
      })
    );

    this.destroy$.next();
    this.destroy$.complete();
  }

  public isDetailsLayoutHandler(): void {
    this.detailsLayout = !this.detailsLayout;
    this.statistics.isDetailsLayoutHandler(this.detailsLayout);
  }

  public sortValueHandler(val: IChosenSortValue): void {
    this.choosenSortValue = val;
    this.statistics.setSortMethod({ sortMethod: val, origin: 'header' });
    this.statisticsTableService.setSortMethod(val);
  }
}
